(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    module.directive('taskReaction', [function () {
        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/tasks/templates/task-reaction.template.html'
        };
        return directive;

        function link(scope, element, attrs) {
            //scope.inOut = 'in';
            //if (SharedAgendaService.getLoggedInUserData().id !== scope.reaction.fK_User) {
            //    scope.inOut = 'out';
            //} // if
        }
    }]);

})();